import React, { useState, useEffect, useRef } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Empty, Select, Pagination, Tooltip, Input } from "antd";

import RTableSelectable from "../RTableSelectable";
import CandidateAddModal from "../CandidateAddModal";
import TextFilter from "../textFilter";
import LexicalSort from "../lexicalSort";
import NumericFilter from "../numericFilter";
import useCandidateStore from "../../store/candidateModal.store";
import useMembersStore from "../../store/members.store";
import "./JDInterviews.scss";
import PieChart from "../PieChart";
import useResumeStore from "../../store/resume.store";
import useSettingstore from "../../store/settings.store";
import useStatsStore from "../../store/stats.store";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  LeftOutlined,
  RightOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";


import { FILTER_DURATION_OPTIONS, OWNERSHIP_OPTIONS, VIEW_FILTER_CONFIG } from "../../helper/categoryconstants";
import { CHECKBOX_WIDTH, COMMUNICATION_COLUMNS_WIDTH, CTC_COLUMNS_WIDTH, HIRING_FLOW_COLUMNS_WIDTH, PERSONAL_DETAIL_COLUMNS_WIDTH, RESUME_ANALYSIS_COLUMNS_WIDTH, SOURCING_TABLE_COLUMNS_WIDTH, SUMMARY_COLUMNS_WIDTH } from "../../helper/tablewidthcontants";
import { GetSourceOwner } from "../../helper/commonFunctions";

const { Search } = Input;

const summaryListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name", 
    'Email', 
    "Mobile",
    "Resume Suitability", 
    "Candidate Status",
    "Extra Analysis",    
    "Resume Status",                     
    "Current Location",
    "Total Exp",
    "Relevant Exp",
    "Current CTC",
    "ECTC",
    "Notice Period", 
    "LWD",        
    "Remarks",
    "Last Updated By",
    "LastUpdated On",
];

const personalListTable = [
    "Sr. No.",
    "Resume ID",
    "Name",
    "Email Id",
    "Mobile",
    "Resume Suitability",
    "Candidate Status",
    "Extra Analysis",    
    "Resume Status",    
    "Aadhar ID",
    "Gender",
    "Current Location",
    "Preferred Location",
    "Designation",
    "Company",
    "Max Degree",
    "Stream",
    "Passing Year",
];

const summaryStatusListTable = [
  "Sr. No.",
  "Resume ID",
  "Name",
  "Email Id",
  "Mobile",  
  "Resume Suitability",
  "Candidate Status",
  "Extra Analysis",    
  "Resume Status",
  "Interview Type",
  "Interview Status",
  "Selection Status",
  "Offer Status",
];

const ctcListTable = [
    "Sr. No.",
    "Resume ID",
    "Name",
    "Email Id", 
    "Mobile",  
    "Resume Suitability",
    "Candidate Status",
    "Extra Analysis",    
    "Resume Status",    
    "Current CTC",
    "ECTC",
    "CTC Remarks",
    "Official NP",
    "Negotiable NP",
    "LWD",
    "Reason for Leaving",
    "Currently Employed",
    "Reason for Not Working",
    "Other Offers",
    "Other Joining Date",
    "Offer CTC",
    "Offer Company Type",
];

const suitablityListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Resume Suitability",     
    "Candidate Status", 
    "Extra Analysis",       
    "Resume Status", 
    "Skill Matrix Suitability",
    "Assessment Suitablity",           
    "Payroll",
    "Total Exp",
    "Relevant Exp",       
    "Skill Tags",
    "Soft Skills", 
    "Comments",
    "Updated By",
    "Updated On",

];
const suitablityListTableInternal = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Job Type (P/TP)",
    "Total Exp",
    "Relevant Exp",       
    "Skill Tags",
    "Soft Skills",
    "Resume Suitability",  
    "Skill Matrix Suitability",
    "Assessment Suitablity",
    "Resume Status",  
    "Comments",
    "Updated By",
    "Updated On",
    "Candidate Status",
];

const sourcingListTable = [
    "Sr. No.",
    "Resume ID",
    "Name", 
    "Email Id",
    "Mobile",
    "Ownership",
    "Name",
    "User ID",
    "Uploading Date",    
    "Source",
];

const interviewListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Mobile",     
    "Resume Status",  
    "Interview Status",        
    "Interview Type",
    "Interview Date",
    "Interview Time",
    "Remarks",
    "No of Reschedules",
    "Updated By",
    "Updated On",
    "Interview History"
];

const selectionListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",  
    "Name",
    "Interview Status",
    "Offer Status", //offered/declined/joinedelesewhere/hold/joined/accepted
    "Docu status",//pending, submitted,issues
    "BGV Status", //oongoing,bgv ok, bgv fail
    "Expected DoJ",
    "ECTC",
    "Offered CTC",
    "Remarks",
    "Updated By",
    "Updated On"
];

const communicationListTable = [
    "Select",
    "Sr. No.",
    "Resume ID",    
    "Name",  
    "Email",
    "Phone",
    "Resume Suitability",    
    "Candidate Status", 
    "Extra Analysis",              
    "Resume Status",
    "Candidate Interest Mails",
    "Slot Mails",
    "Interview Reminder Mails",
    "Feedback Reminder Mails"
];
const resumeAnalysisListTable = [
    "Sr. No.",
    "Resume ID",
    "Name", 
    "Email",
    "Phone",    
    "Resume Suitability",
    "Candidate Status", 
    "Extra Analysis",              
    "Resume Status",    
    "Final Analysis",        
    "Skill Analysis",
    "Role Analysis",
    "Education Analysis",
    "Exp Analysis",
    "Mentioned Exp (Y)",   
    "Cumulative Exp (Y)",
    "Expected Exp (Y)", 
    "Barred Company",
    "Grammer",
    "Barred College",
    "Parsing Errors",
    "Missing Skills"
];
const resumeViewMap = {
  summary: "Summary",
  resume_analysis_table: "Resume Analysis Table",
  personal: "Personal",
  ctc: "CTC and NP",
  skills: "Resume Status",
  interview: "Interviews",
  selections: "Selections and Offers",
  automated_sourcing: "Automated Sourcing",
  communications: "Communications",
  sourcing: "Sourcing",
};

export default function JDInterviews({ selectedJD }) {
  const [currentView, setCurrentView] = useState("interview");
  const [previousView, setPreviousView] = useState("");
  const [currentFiltersToView, setCurrentFiltersToView] = useState([]);
  const [currentViewFilters, setCurrentViewFilters] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
    const [selectedResumeID, setResumeID] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const { value } = useParams();
  const { teamMembers } = useMembersStore();
    const scrollRef = useRef(null);
  const updatedByList =
    teamMembers?.map((member) => ({
      value: member?.username,
      label: member?.username,
    })) || [];
  const loggedInUser = JSON.parse(localStorage.getItem("userDetails")).username;

  useEffect(() => {
    if (currentFiltersToView.length == 0) {
      setSearchInput("");
    }
  }, [currentFiltersToView]);


  //console.log("Selected JD in Interview Status", selectedJD)
  // const [filterApiParameters, setFilterApiParameters] = useState({
  //   search: "",
  //   sortBy: "interviewStatusUpdateTime",
  //   sortOrder: "",
  //   "Total Experience": "All",
  //   "Relevant Experience": "All",
  //   "Current CTC": "All",
  //   ECTC: "All",
  //   "Notice Period": "All",
  //   "Candidate Status": ['Available'],
  //   "Resume Suitability": selectedJD?.JDOther.AllowNonSuitable ? [] : ['Below Average','Average','Above Average','Good Match','Partial Suitable'],
  //   "Resume Status": ['Shared','To Be Shared','Feedback Pending','Client Feedback Pending','Duplicate','Interview Rejected','Screen Selected','Screen Partial Suitable'],
  //   "Education Analysis": [],
  //   "Experience Analysis": [],
  //   "Parsing Errors": [],
  //   Gender: [],
  //   "Reason For Leaving": [],
  //   "Reason For Not Working": [],
  //   "Other Offers": [],
  //   Payroll: [],
  //   "Skill Matrix Suitability": [],
  //   "Assessment Suitability": [],
  //   "Interview Status": [],
  //   "Interview Type": [],
  //   "Offer Status": [],
  //   Ownership: [],
  //   "Source By": [loggedInUser],
  //   "Updated By": [],
  // });


  const key = "jdInterviews";
    
      const defaultFilters = {
        search: "",
        sortBy: "interviewStatusUpdateTime",
        sortOrder: "",
        "Total Experience": "All",
        "Relevant Experience": "All",
        "Current CTC": "All",
        ECTC: "All",
        "Notice Period": "All",
        "Candidate Status": ['Available'],
        "Resume Suitability": selectedJD?.JDOther.AllowNonSuitable ? [] : ['Below Average','Average','Above Average','Good Match','Partial Suitable'],
        "Resume Status": ['Shared','To Be Shared','Feedback Pending','Client Feedback Pending','Duplicate','Interview Rejected','Screen Selected','Screen Partial Suitable'],
        "Education Analysis": [],
        "Experience Analysis": [],
        "Parsing Errors": [],
        Gender: [],
        "Reason For Leaving": [],
        "Reason For Not Working": [],
        "Other Offers": [],
        Payroll: [],
        "Skill Matrix Suitability": [],
        "Assessment Suitability": [],
        "Interview Status": [],
        "Interview Type": [],
        "Offer Status": [],
        Ownership: [],
        "Source By": [],
        "Updated By": [],
      };


  const savedSetting = getSettingByKey(key);
           
  // defaults first, then saved values on top, so newly added filters still get a default
  const saved = { ...defaultFilters, ...savedSetting?.value };

  // default values + anything else the user had selected, no duplicates
  const mergeWithDefault = (filterName) => [
    ...new Set([...defaultFilters[filterName], ...saved[filterName]]),
  ];

  const startingFilters = {
    ...saved,
    "Candidate Status": mergeWithDefault("Candidate Status"),
    "Resume Suitability": mergeWithDefault("Resume Suitability"),
    "Resume Status": mergeWithDefault("Resume Status"),
    "Source By": mergeWithDefault("Source By"),
  };

  const [filterApiParameters, setLocalFilters] = useState(startingFilters);

  const setFilterApiParameters = (newFilters) => {
    setLocalFilters(newFilters);
    addOrUpdateSetting({ key, value: newFilters });
  };
      

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const { setCandidateModalOpen } = useCandidateStore();
  const [importRefreshFlag, setImportRefreshFlag] = useState(false);
  const [durationChange, setDurationChange] = useState(false);
  const {
    resumes,
    getResumesByJD,
    updateResume,
    downloadResumeByID,
    allApplications,
    getAllApplicationsByJD,
    setUpdateInterviewStatusFlag,
    updateFlagSpecific,
    updateInterviewStatusFlag,
    resetUpdateFlagSpecific,
    resetSelectedProfileResume,
    resetSelectedApplication,
    resetUpdateInterviewStatusFlag,
    selectedJDMapData,
    totalapplications,
  } = useResumeStore();

  const handlePageChange = (page, pageSize) => {
    console.log("Page:", page, "PageSize:", pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const setFilterParameters = (newFilters) => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));

  };
  const [previousFilterState, setPreviousFilterState] = useState(null);

  const pullAvailableData = () => {
    // Store current filter state before changing to Available
    console.log("Storing previous filter state in pull:", filterApiParameters);
    
    // Store the current state before updating
    const currentState = { ...filterApiParameters };
    setPreviousFilterState(currentState);
    
    setFilterApiParameters(prevFilters => ({
      ...prevFilters,
    }));
  };

  const restorePreviousData = () => {
    console.log("Restoring previous filter state:", previousFilterState);
    
   
      // If no previous state, just remove "Available" from current filters
      setFilterApiParameters(prevFilters => ({
        ...prevFilters,
        "Candidate Status": prevFilters["Candidate Status"].filter(status => status !== "Available")
      }));
    setPreviousFilterState(null); // Clear stored state after restoring
    
  };

  useEffect(() => {  
    //console.log("User Effects for init and filter change", filterApiParameters);
    getAllApplicationsByJD(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("interviews.duration"));
  }, [filterApiParameters, currentPage, pageSize, importRefreshFlag]);

  
  useEffect(() => {
    resetUpdateInterviewStatusFlag();
  }, []);

    useEffect(() => {
        if(updateInterviewStatusFlag || updateFlagSpecific ||durationChange){
            //getResumesByJD(value);
            console.log("Fetching all applications due to update flag");
            getAllApplicationsByJD(value, filterApiParameters, currentPage, pageSize,localStorage.getItem("interviews.duration"));
            resetUpdateInterviewStatusFlag()
            resetUpdateFlagSpecific()
            setDurationChange(false)
        }
    }, [updateInterviewStatusFlag,updateFlagSpecific,durationChange]);
  

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const checkScroll = () => {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    checkScroll();
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scroll = (direction) => {
    const el = scrollRef.current;
    const scrollAmount = 500;
    if (direction === "left") el.scrollLeft -= scrollAmount;
    else el.scrollLeft += scrollAmount;
  };
    const handleDownloadResume = (resumeID) => {
        downloadResumeByID(value, resumeID);
    };


   const GetUpdatedByDetails = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {               
            return {
                updatedByName:allApplications[idx]?.candidatestatus?.updatedby.name,
                updatedOn:allApplications[idx]?.candidatestatus?.updatedby.updatedon,
                status:allApplications[idx]?.candidatestatus?.status
        } 
       }
     }
   }
   const GetResumeScore = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {   
            return ({
                finalScore: allApplications[idx]?.resumescore.score
        }) 
       }
     }
   }
   
   const GetNoticePeriod = (qhrid)=>{
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return ({
                officialnp: resumes[idx]?.employmentdetails.noticeperiod.officialnp,
                lwd: resumes[idx]?.employmentdetails.noticeperiod.lwd
        }) 
       }
     }
   }

   function GetResumeDetails(qhrid){
    for(let idx = 0; idx < resumes?.length; idx++){  
        if (resumes[idx]?.qhrid === qhrid) {
            return (
                 resumes[idx]
        ) 
       }
     }
   }
   const GetLastUpdated = (appDetail)=>{
        if(appDetail.resumestatus.updatedby.timestamp === 0 ){
            return ({
                updatedBy: appDetail.candidatestatus.updatedby.name,
                updatedOn: appDetail.candidatestatus.updatedby.updatedon
        })
        }
        else if (appDetail.candidatestatus.updatedby.timestamp > appDetail.resumestatus.updatedby.timestamp) {  
            return ({
                updatedBy: appDetail.candidatestatus.updatedby.name,
                updatedOn: appDetail.candidatestatus.updatedby.updatedon
        }) 
       }else{
        return ({
            updatedBy: appDetail.resumestatus.updatedby.name,
            updatedOn: appDetail.resumestatus.updatedby.updatedon
        })
       }
   }

   const GetLastUpdatedSelections = (appDetail)=>{

    //find which one is latest timestamp
    if((appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )
        && (appDetail?.selectionstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.selectionstatus?.updatedby.name,
            updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }
    else if((appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.bgvstatus?.updatedby.timestamp > appDetail?.documentsstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.bgvstatus?.updatedby.name,
            updatedOn: appDetail?.bgvstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    }else if((appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.selectionstatus?.updatedby.timestamp )
        && (appDetail?.documentsstatus?.updatedby.timestamp > appDetail?.bgvstatus?.updatedby.timestamp )){
        return ({
            updatedBy: appDetail?.documentsstatus?.updatedby.name,
            updatedOn: appDetail?.documentsstatus?.updatedby.updatedon,
            remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
    } else{
    return ({
        updatedBy: appDetail?.selectionstatus?.updatedby.name,
        updatedOn: appDetail?.selectionstatus?.updatedby.updatedon,
        remarks: appDetail?.selectionstatus?.updatedby.remarks
    })
   }
}
   const GetApplicationData = (qhrid)=>{
    for(let idx = 0; idx < allApplications?.length; idx++){  
        if (allApplications[idx]?.qhrid === qhrid) {   
            return allApplications[idx] 
        }
        return null
     }
     return null
    } 
    const GetPreferredLocation = (appDetail)=>{
        var loc =""
        for(let idx = 0; idx < appDetail?.newemploymentdetails?.preferredlocation?.length; idx++){
            if(idx >0){
                loc = loc + ","
            }  
            loc = loc + appDetail?.newemploymentdetails?.preferredlocation?.[idx]
            return loc
         }
         return loc
        } 

    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   
    
  const extraAnalysisData = (extraanalysis) =>{
      let str = "Suitable";
      if(extraanalysis?.ishighctc ){
        str = "HCTC"
      }
      if (extraanalysis?.ishighnp){
        if(str == "HCTC") {
          str = str + " / "         
          str = str + "HNP"
        }else{
          str = "HNP"
        }
      }
      return str
  }
    const summaryDataNew = allApplications?.map((appDetail, idx) => {
        let nPeriod = GetNoticePeriod(appDetail?.qhrid) 
        let lUpdate = GetLastUpdated(appDetail)   
        var resumeDetail = GetResumeDetails(appDetail?.qhrid)
        //console.log("Summary New Data current page",currentPage,pageSize)
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name, 
            email: appDetail?.applicationid.email,
            mobile: appDetail?.applicationid.mobile, 
            resumeSuitability:appDetail?.resumescore?.scorestr,    
            candidateStatus: appDetail?.candidatestatus?.status, 
            extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,             
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,                                  
            currentLocation: resumeDetail?.employmentdetails?.currentlocation,           
            totalexp: appDetail?.newemploymentdetails.totalexp,
            relevantexp: appDetail?.newemploymentdetails.relevantexp,
            cCTC: resumeDetail?.employmentdetails.currentctc?.totalctc,
            ECTC: appDetail?.newemploymentdetails.ectc.totalctc,
            noticePeriod: nPeriod?.officialnp == 1024?"":nPeriod?.officialnp, 
            lwd: nPeriod?.officialnp == 1024?"":nPeriod?.lwd, 
            remarks: appDetail?.newemploymentdetails?.otherremarks,
            uploadedBy: appDetail?.interviewstatus.updatedby==""?"--":appDetail?.interviewstatus.updatedby.name,
            dateAdded: appDetail?.interviewstatus.updatedby.timestamp?formatUnixDate(appDetail?.interviewstatus.updatedby.timestamp):"--",

    };
  });

  const summaryStatusData = allApplications?.map((appDetail, idx) => {
    return {
      id: idx+1+ (currentPage-1)*pageSize,
      qhid: appDetail?.resumeData?.qhrid,
      name: appDetail?.resumeData?.personaldetail.name,
      email: appDetail?.resumeData?.personaldetail.email,
      mobile: appDetail?.resumeData?.personaldetail.mobile,      
      resumeSuitability:appDetail?.resumescore?.scorestr,
      candidateStatus: appDetail?.candidatestatus?.status,
      extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,       
      resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,    
      interviewType: appDetail?.interviewstatus?.type,
      interviewStatus: appDetail?.interviewstatus?.status,
      selectionStatus: appDetail?.selectionstatus?.status,
      offerStatus: appDetail?.offerstatus?.status,
    };
  });

  const personalDetailsData = allApplications?.map((appDetail, idx) => {
    var resumeDetail = GetResumeDetails(appDetail?.qhrid);
    var pLoc = GetPreferredLocation(appDetail);

        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:resumeDetail?.qhrid,
            name: resumeDetail?.personaldetail.name,
            email: resumeDetail?.personaldetail.email,
            phone: resumeDetail?.personaldetail.mobile,
            resumeSuitability:appDetail?.resumescore?.scorestr,
            candidateStatus: appDetail?.candidatestatus?.status,
            extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,       
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,             
            aadhar: resumeDetail?.personaldetail.aadharid,
            gender: resumeDetail?.personaldetail.gender,
            currentLocation: resumeDetail?.employmentdetails?.currentlocation, 
            preferredLocation: appDetail?.newemploymentdetails?.preferredlocation !=null ? appDetail?.newemploymentdetails?.preferredlocation:"--",          
            currentDesignation: resumeDetail?.employmentdetails.designation,
            currentCompany: resumeDetail?.employmentdetails?.currentcompany,
            maxDegree: resumeDetail?.educationaldetail.maxdegree,
            stream: resumeDetail?.educationaldetail.stream, 
            passoutyear: resumeDetail?.educationaldetail.passoutyear,           
        };
    });    

    const ctcDetailsData = allApplications?.map((appDetail, idx) => {
        var resumeDetail = GetResumeDetails(appDetail?.qhrid)
        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:resumeDetail?.qhrid,
            name: resumeDetail?.personaldetail.name,
            email: resumeDetail?.personaldetail.email,
            phone: resumeDetail?.personaldetail.mobile, 
            resumeSuitability:appDetail?.resumescore?.scorestr,
            candidateStatus: appDetail?.candidatestatus?.status,
            extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,       
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,                         
            cCTC: resumeDetail?.employmentdetails.currentctc?.totalctc,
            eCTC: appDetail?.newemploymentdetails?.ectc?.totalctc,
            remarksCTC: appDetail?.newemploymentdetails?.ectc?.ctcremarks,
            noticePeriodOfficial: resumeDetail?.employmentdetails?.noticeperiod?.officialnp==1024?"":resumeDetail?.employmentdetails.noticeperiod.officialnp,
            noticePeriodNegotiable: resumeDetail?.employmentdetails?.noticeperiod?.negotiableto==1024?"":resumeDetail?.employmentdetails.noticeperiod.negotiableto,            
            LWD: resumeDetail?.employmentdetails.noticeperiod.lwd,
            reasonLeaving: resumeDetail?.employmentdetails.noticeperiod.reason,
            currentlyWorking: "",
            reasonNotWorkding:"",
            oOffer: resumeDetail?.offerdetails.otheroffer,
            oDOJ: resumeDetail?.offerdetails.offerdoj,
            oCTC: resumeDetail?.offerdetails.offerctc,
            oCompany: resumeDetail?.offerdetails.companytype,  
        };
    });   

    const GetSuitabilityData = (qhrid)=>{
        for(let idx = 0; idx < resumes?.length; idx++){  
            if (resumes[idx]?.qhrid === qhrid) {   
                return ({
                    np: resumes[idx]?.noticeperiod
            }) 
           }
         }
    }


    const suitabilityData = allApplications?.map((appDetail, idx) => {
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,  
            resumeSuitability: appDetail?.resumescore?.scorestr,  
            candidateStatus: appDetail?.candidatestatus?.status, 
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status, 
            skillMatix: appDetail?.skillmatix,
            assesment: appDetail?.assesment,                                                                    
            payroll: appDetail?.newemploymentdetails.payroll,
            totalExp:appDetail?.newemploymentdetails.totalexp,
            relExp:appDetail?.newemploymentdetails.relevantexp,
            skills: appDetail?.resumestatus?.tags,  
            softskills: appDetail?.newemploymentdetails?.softskills,       
            resumeComments: appDetail?.resumestatus?.updatedby.remarks,
            updatedBy: appDetail?.resumestatus?.updatedby.name,
            updateOn: appDetail?.resumestatus?.updatedby.updatedon,
        };
    });

    const interviewData = allApplications?.map((appDetail, idx) => {
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            phone: appDetail?.applicationid.mobile, 
            resumeStatus: appDetail?.resumestatus.status,  
            iStatus: appDetail?.interviewstatus?.status?appDetail?.interviewstatus?.status:"--",                      
            iType: appDetail?.interviewstatus?.type?appDetail?.interviewstatus?.type:"--",
            iDate: appDetail?.interviewstatus?.interviewdate?appDetail?.interviewstatus?.interviewdate:"--",
            iTime: appDetail?.interviewstatus?.interviewtime?appDetail?.interviewstatus?.interviewtime:"--",
            interviewComments:appDetail?.interviewstatus?.updatedby.remarks,
            numResch: appDetail?.interviewstatus?.numrescheduled?appDetail?.interviewstatus?.numrescheduled:"--",
            updatedBy: appDetail?.interviewstatus?.updatedby.name,
            updateOn: appDetail?.interviewstatus?.updatedby.updatedon,
            history:"Click Here"
        };
    });  


    const selectionData = allApplications?.map((appDetail, idx) => {
        let lUpdate = GetLastUpdatedSelections(appDetail)  
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            interviewStatus: appDetail?.interviewstatus?.status?appDetail?.interviewstatus?.status:"--",
            sStatus: appDetail?.selectionstatus?.status?appDetail?.selectionstatus?.status:"--",
            dStatus: appDetail?.documentsstatus?.status?appDetail?.documentsstatus?.status:"--",
            bgvStatus: appDetail?.bgvstatus?.status?appDetail?.bgvstatus?.status:"--",
            eDoJ: appDetail?.newemploymentdetails?.finaldoj,
            eCTC: appDetail?.newemploymentdetails?.ectc?.totalctc,
            oCTC: appDetail?.newemploymentdetails?.octc?.totalctc,
            selectComments:lUpdate?.remarks,
            uploadedBy: lUpdate?.updatedBy,
            dateAdded: lUpdate?.updatedOn,
        };
    });    

    const GetCommunicationInterestDate = (appDetail)=>{
        var len = appDetail?.communicationhistory?.interest !=null? appDetail?.communicationhistory?.interest?.length:0
        var dtString = "--"
        if ((len >0) &&((len <30)))
          dtString = "("+ len + ") "+ appDetail?.communicationhistory?.interest?.[len-1]?.senton
        return dtString
    }    

    const sourcingData = allApplications?.map((appDetail, idx) => {
        var thisresume = GetResumeDetails(appDetail?.qhrid)
        var sOwner =GetSourceOwner(appDetail)
        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            email: appDetail?.applicationid.email, 
            phone: appDetail?.applicationid.mobile,            
            method: OWNERSHIP_OPTIONS.find((option) => option.value === appDetail?.sourcingdetails?.method)?.label || "Unknown",
            sName:sOwner.sourceName,
            sID:sOwner.sourceID,
            dateAdded: sOwner.sourceDate,            
            resumesource: thisresume?.firstuploadedby?.resumesource !== "By Candidate" ? thisresume?.firstuploadedby?.resumesource : "NuJobs",
        };
    });
    const colorData = allApplications?.map((appDetail, idx) => {
        var method =appDetail?.sourcingdetails?.method
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            color: method === "By Team" ? "#d5e9fe" : 
                   method === "By Vendor" ? "#ff69b4" : method === "Through Career Page" ? "#1890ff" : 
                   method== "By Automation"? "#e3f6d7":"#cfd7f7"
        };
    });
    const communicationData = allApplications?.map((appDetail, idx) => {
        var sOwner = GetSourceOwner(appDetail)
        var interestDate = GetCommunicationInterestDate(appDetail)
        return {
            select:"",
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name,
            email: appDetail?.applicationid.email,
            phone: appDetail?.applicationid.mobile,     
            resumeSuitability:appDetail?.resumescore?.scorestr,    
            candidateStatus: appDetail?.candidatestatus.status,   
            extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,                       
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,    
            interested: GetCommunicationInterestDate(appDetail),
            slot:appDetail?.communicationhistory?.slot?.length,
            interview: appDetail?.communicationhistory?.reminder?.length,
            feedback: appDetail?.communicationhistory?.feedback?.length
        };
    });
    
    const resumeAnalysisData = allApplications?.map((appDetail, idx) => {
        const scorelist = appDetail?.resumescore?.scorelist || {};
        const keywordsObj = scorelist?.skill_scores?.keywords || {};
        const keywordString = Object.entries(keywordsObj)
          .filter(([_, value]) => (value.avg ?? 0) === 0) // Filter keywords with avg > 0
          .map(([key]) => key)
          .join(", ");      
        return {
            id: idx+1+ (currentPage-1)*pageSize,
            qhid:  appDetail?.qhrid,
            name: appDetail?.applicationid.name, 
            email: appDetail?.applicationid.email,
            mobile: appDetail?.applicationid.mobile,               
            resumeSuitability:appDetail?.resumescore?.scorestr,
            candidateStatus: appDetail?.candidatestatus?.status,
            extraAnalysis: extraAnalysisData(appDetail?.extraanalysis) ,       
            resumeStatus: appDetail?.resumestatus?.status=="NA"?"--":appDetail?.resumestatus?.status,                
            resumeSuitabilityScore: appDetail?.resumescore?.score + " %",                               
            skillAna: appDetail?.resumescore.scorelist.skill_scores.score + " %",
            roleAna:appDetail?.resumescore.scorelist.role_scores.score  + " %",
            eduAna:appDetail?.resumescore.eduverdict?.verdict,
            expAna:appDetail?.resumescore.expverdict?.verdict,
            menExp: appDetail?.resumescore.expparsed,  
            cumExp: appDetail?.resumescore.cumulativeexp?.[0]?.c_yrs_months,          
            totalExp: appDetail?.resumescore.cumulativeexp?.[0]?.e_yrs_months,
            barredCom: "--",
            grammer: "--",
            barredColl: "--",       
            eduError: appDetail?.resumescore?.eduerrortype,
            matchingSkills: keywordString 
        };
    });

    const handleResumeProfile= (jdId,id,rid) => {
        resetSelectedProfileResume (value,rid)
        resetSelectedApplication (value,rid)
        setResumeID(rid)
    };

    const handleResumeQualityId= (rid) => {
    };


    const handleCurrentViewProfile = () =>{
        setPreviousView(currentView);    
        setCurrentView("profile")
    }
    const handleCurrentViewResumeQuality = () =>{
        setCurrentView("resume_analysis_table") 
    }


    const handleDuration =(dur)=>{
        console.log("Current Interview duration", dur)
        localStorage.setItem("interviews.duration", dur);
        setDurationChange(true)
      }
    const getDurationlabel =()=>{     
         var dur = localStorage.getItem("interviews.duration")
         if(dur =="All"){
           return 'All Resumes'
         }else {
           var durInt = parseInt(dur, 10)
           if( durInt < 48){
              return 'Updated in Last '+ dur + ' hrs'
           }else
            return 'Updated in Last '+ dur/24 + ' days'
         }
      }

  const chartInfo = () => {
    return (
      <>
        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "5px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Avaible
          </div>
          <div className="chart-section-item">
            {" "}
            <span>A</span> - Available
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AHCTC</span> - Available HCTC
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AHNP</span> - Available HNP
          </div>
          <div className="chart-section-item">
            {" "}
            <span>DP</span> - Duplicate Profile
          </div>
        </div>
        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Need to Call
          </div>
          <div className="chart-section-item">
            {" "}
            <span>S</span> - Sourced
          </div>
          <div className="chart-section-item">
            {" "}
            <span>TBC</span> - To be Called
          </div>
          <div className="chart-section-item">
            {" "}
            <span>CL</span> - Call Later
          </div>
          <div className="chart-section-item">
            {" "}
            <span>JD</span> - JD Needed
          </div>
          <div className="chart-section-item">
            {" "}
            <span>NP</span> - Not Picking
          </div>
          <div className="chart-section-item">
            {" "}
            <span>B/D</span> - Busy/Disconnected
          </div>
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Suitability
          </div>
          <div className="chart-section-item">
            {" "}
            <span>NS</span> - Not Suitable
          </div>
          <div className="chart-section-item">
            {" "}
            <span>BA</span> - Below Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>A</span> - Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>AA</span> - Above Average
          </div>
          <div className="chart-section-item">
            {" "}
            <span>GM</span> - Good Match
          </div>
          <div className="chart-section-item">
            {" "}
            <span>PS</span> - Partial Suitable
          </div>            
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Resume Status
          </div>
          <div className="chart-section-item">
            {" "}
            <span>S</span> - Shared
          </div>
          <div className="chart-section-item">
            {" "}
            <span>IRP</span> - Interview Planned
          </div>
          <div className="chart-section-item">
            {" "}
            <span>TBS</span> - To Be Scheduled
          </div>
        </div>

        <div className="chart-section">
          <div
            className="chart-section-title"
            style={{
              backgroundColor: "#b8e0ff",
              marginTop: "10px",
              paddingLeft: "6px",
              borderRadius: "12px",
              color: "#000000ff",
            }}
          >
            Resume Feedbacks
          </div>
          <div className="chart-section-item">
            {" "}
            <span>FBP</span> - Feedback Pending
          </div>
          <div className="chart-section-item">
            {" "}
            <span>CFBP</span> - Client Feedback Pending
          </div>
          <div className="chart-section-item">
            {" "}
            <span>SR</span> - Screen Reject
          </div>
          <div className="chart-section-item">
            {" "}
            <span>D</span> - Duplicate
          </div>
          <div className="chart-section-item">
            {" "}
            <span>IR</span> - Interview Reject
          </div>
          <div className="chart-section-item">
            {" "}
            <span>SS</span> - Screen Select
          </div>
        </div>
      </>
    );
  };

  const handleSearch = () => {
    setFilterApiParameters((prevFilters) => ({
      ...prevFilters,
      search: searchInput,
    }));
  };

  const updateViewFilterConfig =()=>{
      let finalConfig = VIEW_FILTER_CONFIG;
      const injectOptions = (config, key, options) =>
        config.map((item) =>
          item.key === key
            ? { ...item, options }
            : item
        );      
      finalConfig = injectOptions(finalConfig, "Updated By", updatedByList)
      finalConfig = injectOptions(finalConfig,"Source By",updatedByList);
      finalConfig = injectOptions(finalConfig,"Candidate Status Updated By",updatedByList);
      return finalConfig  
  }  
  const handleProfileBackBtn = () => {
    navigate(`/jds/${value}`);
    setCurrentView(previousView);
  };
  return (
    <div className="jd-interviews-wrapper">
      {currentView !== "profile" && (
        <>
            <div className="section-header">
                   <h3 className="title">Interviews {" (" + totalapplications+ ") "}</h3>
	            <div className="section-header-input">
	              <Search
	                placeholder="Search by Name/Mobile/Email/Resume ID"
	                size="small"
	                value={searchInput}
	                onChange={(e) => setSearchInput(e.target.value)}
	                onSearch={handleSearch}
	                style={{ width: 350, height: 24, marginRight: 12 }}
	              />
                    <Select
                        style={{ width: 230,height: 24 }}
                        onChange={handleDuration}
                        showSearch={true}
                        filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}                  
                        placeholder={getDurationlabel()}                                                  
                        options={FILTER_DURATION_OPTIONS} 
                    /> 
                   </div>
          </div>
          <div className="jd-interviews-buttons-wrapper-container">
            {canScrollLeft && (
              <div
                className="jd-interviews-arrow-btn"
                onClick={() => scroll("left")}
              >
                <LeftOutlined />
              </div>
            )}
            <div className="jd-interviews-buttons-wrapper" ref={scrollRef}>
              <Button
                className={`jd-interviews-btn ${
                  currentView === "interview" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("interview")}
              >
                Interviews
              </Button>

                <Button
                className={`jd-interviews-btn ${
                  currentView === "summary-status" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("summary-status")}
              >
                Hiring Flow
              </Button>
              <Button
                className={`jd-interviews-btn ${
                  currentView === "ctc" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("ctc")}
              >
                CTC and NP
              </Button>

              <Button
                className={`jd-interviews-btn ${
                  currentView === "communications" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("communications")}
              >
                Communications
              </Button>
              <Button
                className={`jd-interviews-btn ${
                  currentView === "sourcing" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("sourcing")}
              >
                Sourcing
              </Button>
              <Button
                className={`jd-interviews-btn ${
                  currentView === "charts" && "jd-interviews-btn-active"
                }`}
                onClick={() => setCurrentView("charts")}
              >
                Charts
              </Button>
            </div>{" "}
            {canScrollRight && (
              <div
                className="jd-interviews-arrow-btn"
                onClick={() => scroll("right")}
              >
                <RightOutlined />
              </div>
            )}
          </div>
          <div className="resumes-info-wrapper">
            <div className="resumes-chart">
              {currentView !== "charts" && (
                <>
                  <PieChart
                    pieData={selectedJDMapData}
                    status={"candidatestatus"}
                    displayText={"Need to Call"}
                  />
                </>
              )}
            </div>
            <div className="global-filter">
              <TextFilter
                currentView={resumeViewMap[currentView]}
                setCurrentPage={setCurrentPage}
                config={updateViewFilterConfig()}
                globalFilterData={filterApiParameters}
                setGlobalFilterData={setFilterApiParameters}
                defaultFilters={defaultFilters}
                lexicalsort={<LexicalSort                 
                               globalFilterData={filterApiParameters}
                               setGlobalFilterData={setFilterApiParameters}/>}   
              />

              <NumericFilter />
            </div>
          </div>
        </>
      )}
      {resumes ? (
        <div className="jd-interviews-container">
          {currentView === "charts" ? (
            <>
              <div className="chart-summary">
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Available"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Need to Call"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Suitability"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Resume Status"}
                />
                <PieChart
                  pieData={selectedJDMapData}
                  status={"candidatestatus"}
                  displayText={"Resume Feedbacks"}
                />
                <div
                  id="fixed-tooltip-container"
                  className="chart-info"
                  style={{ position: "fixed", top: 0, left: 0, zIndex: 9999 }}
                ></div>

                <Tooltip
                  title={chartInfo()}
                  color="white"
                  overlayInnerStyle={{
                    color: "grey",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                  placement="bottomRight"
                  getPopupContainer={() =>
                    document.getElementById("fixed-tooltip-container")
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </div>
            </>
          ) : currentView === "personal" ? (
            <RTableSelectable
              isClickable
              titleList={personalListTable}
              //data={personalDetailsData?.filter(checkStatus)}
              data={personalDetailsData}
	            colorData = {colorData} 
              isResumePage
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}                
              jdID={value}
              columnWidth={PERSONAL_DETAIL_COLUMNS_WIDTH}
              viewname={"JDInterview"}
            />
          ) : currentView === "summary-status" ? (
            <RTableSelectable
              isClickable
              titleList={summaryStatusListTable}
              data={summaryStatusData}
              colorData = {colorData}              
              isResumePage
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}              
              jdID={value}
              columnWidth={HIRING_FLOW_COLUMNS_WIDTH}
              viewname={"JDInterview"}
            />
          ) : currentView === "ctc" ? (
            <RTableSelectable
              titleList={ctcListTable}
              data={ctcDetailsData}
              colorData = {colorData}
              //data={ctcDetailsData?.filter(checkStatus)}
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}
              qhjid={value}
              columnWidth={CTC_COLUMNS_WIDTH} 
              viewname={"JDInterview"}      
            />
          ) : currentView === "skills" ? (
            <>
              <RTableSelectable
                titleList={suitablityListTable}
                //data={suitabilityData?.filter(checkStatus)}
                colorData = {colorData}
                data={suitabilityData}
                isEditField={true}
                pullAvailableData={pullAvailableData}
                restorePreviousData={restorePreviousData}
                setFilterParameters={setFilterParameters}
                qhjid={value}
                selectable="R Only"
                columnWidth={[
                  50, 50, 100, 200, 100, 100, 100, 100, 100, 130, 200, 200, 300,
                  300, 100, 100, 150,
                ]}
	        viewname={"JDInterview"}        
              />
            </>
          ) : currentView === "interview" ? (
            <>
              <RTableSelectable
                isClickable={true}
                isEditField={true}
                titleList={interviewListTable}
                data={interviewData}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                pullAvailableData={pullAvailableData}
                restorePreviousData={restorePreviousData}                
                qhjid={value}
                columnWidth={[
                  50, 50, 100, 200, 100, 150, 200, 200, 200, 200, 200, 100, 100,
                  100, 100,
                ]}
		           colorData = {colorData} 
	             viewname={"JDInterview"}       
              />
            </>
          ) : currentView === "selections" ? (
            <>
              <RTableSelectable
                isClickable={true}
                isResumePage
                isEditField={true}
                titleList={selectionListTable}
                data={selectionData}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                pullAvailableData={pullAvailableData}
                restorePreviousData={restorePreviousData}                
                qhjid={value}
                columnWidth={[
                  50, 50, 100, 150, 150, 250, 250, 250, 100, 100, 100, 250, 100,
                  100,
                ]}
              colorData = {colorData} 
              viewname={"JDInterview"}       
              />
            </>
          ) : currentView === "sourcing" ? (
            <RTableSelectable
              titleList={sourcingListTable}
              data={sourcingData}
              colorData = {colorData}              
              isEditField={false}
              setCurrentView={handleCurrentViewProfile}
              resumeProfileHandler={handleResumeProfile}
              filterParameters={filterApiParameters}
              setFilterParameters={setFilterParameters}
              setImportRefreshFlag={setImportRefreshFlag}
              qhjid={value}
              columnWidth={SOURCING_TABLE_COLUMNS_WIDTH}
              viewname={"JDInterview"}              
            />
          ) : currentView === "profile" ? (
            <>
              <Outlet context={{ handleProfileBackBtn }} />
            </>
          ) : currentView === "communications" ? (
              <RTableSelectable
                comActions = {true}
                isClickable={true}
                isResumePage
                titleList={communicationListTable}
                data={communicationData}
                colorData = {colorData}
                isEditField={true}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                qhjid={value}
                 columnWidth={[CHECKBOX_WIDTH,...COMMUNICATION_COLUMNS_WIDTH]}

                viewname={"JDInterview"}                
            />
          ) : (
            <>
              <RTableSelectable
                isClickable={true}
                isResumePage
                titleList={summaryListTable}
                data={summaryDataNew}
                colorData = {colorData}
                setCurrentView={handleCurrentViewProfile}
                resumeProfileHandler={handleResumeProfile}
                filterParameters={filterApiParameters}
                setFilterParameters={setFilterParameters}
                setImportRefreshFlag={setImportRefreshFlag}
                qhjid={value}
                selectable="C Only"
                columnWidth={[CHECKBOX_WIDTH,...SUMMARY_COLUMNS_WIDTH]}
                ignoreUpdateActions = {true}
                viewname={"JDInterview"}
              />
            </>
          )}
          {currentView !== "profile" && (
            <Pagination
              style={{
                marginTop: "4px",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "16px",
                marginBottom: "10px",
              }}
              current={currentPage}
              pageSize={pageSize}
              total={totalapplications}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />
            )}
                </div>
            ) : (
                <Empty style={{ margin: "60px" }} >
                    <h4>Upload Resumes Now</h4>
                </Empty>
            )}

            <CandidateAddModal />
         
        </div>
    );
}
